import { render, staticRenderFns } from "./ExamineList.vue?vue&type=template&id=19962af3&scoped=true&"
import script from "./ExamineList.vue?vue&type=script&lang=js&"
export * from "./ExamineList.vue?vue&type=script&lang=js&"
import style0 from "./ExamineList.vue?vue&type=style&index=0&id=19962af3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19962af3",
  null
  
)

export default component.exports